export default __webpack_public_path__ + "static/media/linebreaker.c487b136.png";